export default "__VITE_ASSET__41f171e7__$_?nuxt_component=async&nuxt_component_name=SvgoFreecardano__"